import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import { HeaderModal, Pagination, Toast } from "../../../components";
import image from "../../../assets/images/NoConnect.png";
import imageEn from "../../../assets/images/NoConnect-en.png";
import image1 from "../../../assets/images/Weak.png";
import image1En from "../../../assets/images/Weak-en.png";
import styles from "./ModalLive.module.css";
// import ReactPlayer from "react-player";
import {ReactPlayer} from "../../../components";
import axiosClient from "../../../services/axiosClient";
import streamingClient from "../../../services/streamingClient";
import { OnStatusGreen, OffStatus, WeakConnectStatus } from "../../../components/Icons/Icons";
import { MapContext } from "../../../contexts";

const cx = classNames.bind(styles);
const ModalLive = ({ onClose }) => {
  const { listCameraCode, setListCameraCode, wareCode, group, isGroup } =
    React.useContext(MapContext);
  const [stream, setStream] = useState([]);
  const [warehouseName, setWareHouseName] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const refVideo = useRef(null);

  const getListCamera = useCallback(async (code, group) => {
    try {
      const res = await axiosClient.get(
        `cameraManagement/get-list-camera/?warehouse_code=${code}`,
        {
          params: isGroup
            ? {
              group_code: group ? group : null,
            }
            : {},
        }
      );
      return res;
    } catch (error) {
      if (error?.response?.status === 403) {
        Toast.open('Bạn không có quyền xem camera', 'danger')
      } else {
        Toast.open('Tải video không thành công', 'danger');
      }
    }
  }, [])

  useEffect(() => {
    const getPath = async () => {
      const res = await getListCamera(wareCode, group);
      setWareHouseName(res?.data[0]?.CAMERA?.WAREHOUSE_NAME);
      const json = res.data.map(item => (item?.CAMERA?.CODE));
      const test = res?.data?.map(item => ({ camera_code: item?.CAMERA.CODE }))
      const dataRealTime = res?.data;
      const res2 = await streamingClient.post(
        "/streamManagement/post-list-path-streaming/",
        {
          list_camera: {
            data: test,
          },
        }
      );
      const stream = res2?.stream?.map((item) => {
        const index = dataRealTime?.findIndex((item_1) => item_1?.CAMERA?.CODE === item?.code);
        if (index >= 0 && dataRealTime[index]?.CAMERA?.STATUS_ACTIVE === 0) {
          return item;
        } else if (index >= 0 && dataRealTime[index]?.CAMERA?.STATUS_ACTIVE === 2) {
          return {
            ...item,
            data: [{ PATH: 'no-path', STATUS: 'Weak' }]
          }
        } else {
          return {
            ...item,
            data: [{ PATH: 'no-path', STATUS: 'Off' }]
          }
        }
      })
      setStream(stream);
    };
    getPath();
  }, [wareCode, group]);

  return (
    <div className={cx("container")}>
      <div id="__notification"></div>
      <div className={cx("content")}>
        <HeaderModal onClose={onClose} title={warehouseName ? `Kho ${warehouseName}` : 'Kho không có camera'} />
        <div className={cx("data")}>
          {stream.map((item, index) => {
            if (
              index + 1 > (currentPage - 1) * 1 &&
              index + 1 <= 1 * currentPage
            ) {
              return (
                <div className={cx("stream")} key={index} ref={refVideo} style={refVideo?.current ? {height: `${refVideo.current.clientWidth * 9 / 16}px`} : {}}>
                  {item?.data[0].PATH !== "no-path" ? (
                    <ReactPlayer
                      // className={cx("react-player")}
                      url={`${process.env.REACT_APP_BASE_URL}livestream${item?.data[0].PATH}`}
                      // width={"100%"}
                      // height={"100%"}
                      // playing
                    />
                  ) : (
                    <img
                      src={item?.data[0].STATUS === 'Weak' ?
                        (localStorage?.getItem("laguage") === 'en' ? image1En : image1) :
                        (localStorage?.getItem("laguage") === 'en' ? imageEn : image)}
                      alt={"sub"}
                      style={{
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <div className={cx("setting")}>
                    <div style={{ width: "60%" }} className={cx("name_status")}>
                      <span className={cx("On")}>
                        {item?.data[0].STATUS === "On" ? (
                          <OnStatusGreen />
                        ) : (
                          <WeakConnectStatus />
                        )}
                      </span>

                      <span
                        style={{ fontSize: 12, maxWidth: "100%" }}
                        className={cx("name")}
                      >
                        {item?.name}
                      </span>
                    </div>
                  </div>
                </div>
              );
            } else {
              return <Fragment key={index}></Fragment>;
            }
          })}
        </div>
        <div className={cx("pagination")}>
          {stream?.length > 0 && (
            <Pagination
              onClick={(data) => setCurrentPage(data)}
              onNext={() => setCurrentPage(currentPage + 1)}
              onPrevious={() => setCurrentPage(currentPage - 1)}
              currentPage={currentPage}
              pages={stream.length}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalLive;
